import React from 'react';

import { useKioskManager } from '../../../hooks/useKioskManager';
import ButtonStyled from '../button/Button';
import Icon from '../icon/Icon';
import { IconType } from '../icon/types';
import type { SideProps } from '../types';
import styles from './textButton.module.scss';

type TextButtonProps = SideProps & {
  label: string;
  onClick: () => void;
  disabled?: boolean;
  underline?: boolean;
  capitalize?: boolean;
};

const TextButton: React.FC<TextButtonProps> = ({
  label,
  onClick,
  side = 'left',
  disabled,
  underline,
  capitalize,
}) => {
  const { kiosk, kioskMode } = useKioskManager();

  return (
    <ButtonStyled
      onClick={onClick}
      className={`
        ${styles.textButton} 
        ${styles[side]} 
        ${kiosk && kioskMode && styles[kiosk.model]}
      `}
      disabled={disabled}
      variant="text"
    >
      {side !== 'none' && (
        <Icon
          icon={side === 'left' ? IconType.LEFT : IconType.RIGHT}
          color={'black'}
        />
      )}
      <div
        className={`${styles.textButton__label}  ${
          capitalize && styles.capitalize
        }
        ${underline && styles.underline}`}
      >
        {label}
      </div>
    </ButtonStyled>
  );
};
export default TextButton;
